import React from 'react';
import {Arrow} from '../../assets/arrow';
import {
  TokenTextAppearance,
  TokenTextColor,
} from '@volkswagen-onehub/components-core';
import {useIdMirrorTheme} from '../../hooks/use-id-mirror-theme';
import {
  SliderCircle,
  StyledInputCheckbox,
  StyledSwitch,
  SwitchText,
  SwitchWrapper,
} from './ui/switch-theme-button-styles';

export const SwitchThemeButton = () => {
  const {toggleTheme, isReversed} = useIdMirrorTheme();

  const handleToggle = () => {
    toggleTheme();
  };

  return (
    <SwitchWrapper className="switch-theme-button-wrapper">
      <StyledSwitch className={isReversed ? 'checked' : ''}>
        <StyledInputCheckbox
          type="checkbox"
          checked={isReversed}
          onChange={handleToggle}
        />

        <SwitchText
          isReversed={isReversed}
          appearance={TokenTextAppearance.label150}
          color={isReversed ? TokenTextColor.inverted : TokenTextColor.primary}
          bold
        >
          {isReversed ? 'TAN POLO COMO NUNCA' : 'TAN POLO COMO SIEMPRE'}
        </SwitchText>

        <SliderCircle isReversed={isReversed}>
          <Arrow />
        </SliderCircle>
      </StyledSwitch>
    </SwitchWrapper>
  );
};
